// @flow
import type { CampaignResponse } from '../../sharedTypes';

export const CAMPAIGN = {
  REQUEST_ALL_DATA: 'campaign/request_all_data',
  REQUEST_CHECKOUT_DATA: 'campaign/request_checkout_data',
  RECEIVE_CAMPAIGN: 'campaign/receive_campaign',
  RECEIVE_CAMPAIGN_ERROR: 'campaign/receive_campaign_error',
};

export type RequestAllDataAction = {
  type: typeof CAMPAIGN.REQUEST_ALL_DATA,
  userRole: string | null,
};

export type ReceiveCampaignAction = {
  type: typeof CAMPAIGN.RECEIVE_CAMPAIGN,
  payload: CampaignResponse,
};

export type ReceiveCampaignErrorAction = {
  type: typeof CAMPAIGN.RECEIVE_CAMPAIGN_ERROR,
};

export function receiveCampaign(payload: CampaignResponse): ReceiveCampaignAction {
  return {
    type: CAMPAIGN.RECEIVE_CAMPAIGN,
    payload,
  };
}

export function receiveCampaignError(): ReceiveCampaignErrorAction {
  return {
    type: CAMPAIGN.RECEIVE_CAMPAIGN_ERROR,
  };
}
